// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { section, container, title } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '80px 0 40px',
    '@media (min-width: 1024px)': {
      padding: '60px 0 40px'
    },
    '@media (max-width: 992px)': {
      padding: '60px 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '40px 0 30px'
    }
  },
  container,
  title: {
    ...title,
    marginTop: '10px',
    fontSize: '2.25rem',
    '@media (max-width: 640px)': {
      fontSize: '1.4rem',
      marginBottom: '30px'
    }
  },
  category: {
    '@media (max-width: 640px)': {
      marginBottom: '5px'
    }
  },
  info: {
    display: 'flex',
    listStyle: 'none',
    padding: '0',
    '& li': {
      marginRight: '10px'
    },
    '@media (max-width: 640px)': {
      flexDirection: 'column'
    }
  },
  snsIcon: {
    display: 'flex',
    margin: '0',
    padding: '0'
  },
  action: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  flexItem: {
    listStyle: 'none'
  }
};

export default styles;
